import classnames from 'classnames';
import React, { PropsWithChildren, forwardRef } from 'react';

const CSS = require('./Card.module.scss');

type CardProps = PropsWithChildren<{
  as?: any;
  className?: string;
  moreDepth?: boolean;
  noHover?: boolean;
  moreBorderRadius?: boolean;
  onClick?: () => void;
}>;
const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      children,
      className,
      as: Component = 'div',
      moreDepth,
      noHover,
      moreBorderRadius,
      ...rest
    }: CardProps,
    ref: any,
  ) => {
    const classes = classnames(CSS.Card, className, {
      [CSS.CardMoreDepth]: moreDepth,
      [CSS.NoHover]: noHover,
      [CSS.CardMoreBorderRadius]: moreBorderRadius,
    });
    return (
      <Component className={classes} ref={ref} {...rest}>
        {children}
      </Component>
    );
  },
);

export default Card;
